import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { Router } from '@angular/router';

@Component({
  selector: 'app-initial-drawing-info',
  standalone: true,
  imports: [CommonModule,ReactiveFormsModule,MatIconModule,MatFormFieldModule,MatSelectModule],
  templateUrl: './initial-drawing-info.component.html',
  styleUrl: './initial-drawing-info.component.css'
})
export class InitialDrawingInfoComponent {
 // Properties for selected values
 // Reactive form group for the form
 form: FormGroup;

 // Arrays for options
 drawingNumbers: string[] = ['S003', 'S004', 'S005']; // Example list
 drawingTitles: string[] = ['TYPICAL DETAILS', 'SPECIAL DETAILS']; // Example list

 constructor(private dialog: MatDialog,
  private router: Router,
 ) {
   // Initialize the form group with FormControl for each input
   this.form = new FormGroup({
     drawingNumber: new FormControl('S003'), // Default value
     drawingTitle: new FormControl('TYPICAL DETAILS') // Default value
   });
 }

 // Methods to handle actions
 closeModal() {
  this.dialog.closeAll();
 }

 skipStep() {
   console.log('Step skipped');
   // Add logic for skipping the step
 }

 confirmAndGoToReview() {
   this.router.navigate(['/selected-drawing']);
   this.closeModal();
 }
}
